import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import API_URL from '../config';

import {
  Card,
  FilterRow,
  FieldGroup,
  FieldLabel,
  DateInputWrap,
  FetchBtn,
  Divider,
  StatusText,
  ErrorText,
  StatsGrid,
  MetricCard,
  MetricLabel,
  MetricValue,
  MetricUnit,
  SectionTitle,
} from './statsStyles';

// ─── Helpers ──────────────────────────────────────────────────────────────────

const getName = (name) => {
  if (name === 'er')    return 'Вечерние чтения';
  if (name === 'mr')    return 'Утренние чтения';
  if (name === 'ss')    return 'Субботняя школа';
  if (name === 'bible') return 'Библия';
  if (name === 'radio') return 'Радио';
  return name;
};

// ─── Component ────────────────────────────────────────────────────────────────

const AudioStats = ({ theme }) => {
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchStatistics = useCallback(async () => {
    setLoading(true);
    setError('');
    const start = format(startDate, "yyyy-MM-dd");
    const end   = format(endDate,   "yyyy-MM-dd");
    try {
      const response = await fetch(
        `${API_URL}/api/statistics?startDate=${start}&endDate=${end}`,
        { method: 'GET', headers: { 'Content-Type': 'application/json' } }
      );
      if (!response.ok) throw new Error('Ошибка при получении данных');
      setStats(await response.json());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => { fetchStatistics(); }, [fetchStatistics]);

  const handleSubmit = (e) => { e.preventDefault(); fetchStatistics(); };

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <FilterRow>
          <FieldGroup>
            <FieldLabel>Начало периода</FieldLabel>
            <DateInputWrap>
              <DatePicker
                selected={startDate}
                onChange={setStartDate}
                dateFormat="dd.MM.yyyy"
                required
              />
            </DateInputWrap>
          </FieldGroup>

          <FieldGroup>
            <FieldLabel>Конец периода</FieldLabel>
            <DateInputWrap>
              <DatePicker
                selected={endDate}
                onChange={setEndDate}
                dateFormat="dd.MM.yyyy"
                required
              />
            </DateInputWrap>
          </FieldGroup>

          <FetchBtn type="submit" disabled={loading}>
            {loading ? (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{animation:'spin 1s linear infinite'}}>
                  <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                </svg>
                Загрузка…
              </>
            ) : 'Обновить'}
          </FetchBtn>
        </FilterRow>
      </form>

      {error && <ErrorText>⚠ {error}</ErrorText>}

      {!loading && !error && stats.length > 0 && (
        <>
          <Divider />
          <SectionTitle>Прослушиваний за период</SectionTitle>
          <StatsGrid>
            {stats.map((item, index) => (
              <MetricCard key={index}>
                <MetricLabel>{getName(item.name)}</MetricLabel>
                <MetricValue>
                  {item.totalRequests.toLocaleString('ru-RU')}
                  <MetricUnit>раз</MetricUnit>
                </MetricValue>
              </MetricCard>
            ))}
          </StatsGrid>
        </>
      )}

      {!loading && !error && stats.length === 0 && (
        <StatusText>Нет данных за выбранный период</StatusText>
      )}

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </Card>
  );
};

export default AudioStats;
